import { createRequest } from "helpers/tools";

export const getFunctions = async () => {
    return await createRequest({
        suffix: `lead/functions`,
        method: "get",
        handleError: false,
    });
};
